import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import {List, Map} from 'immutable';
import track from 'react-tracking';
import {callAction} from 'client/framework';
import createAssignmentStore from '../../CreateAssignment.store';
import createAssignmentActions from '../../CreateAssignment.actions';
import CreateAssignmentRecipientItem from '../CreateAssignmentRecipientItem/CreateAssignmentRecipientItem.react';

@track()
class CreateAssignmentRecipientStudents extends React.Component {
  static propTypes = {
    students: ImmutablePropTypes.list,
    classroom: ImmutablePropTypes.record,
    tracking: ImmutablePropTypes.object
  };

  handleSingleSelect = (e, classroomId, classroomName, student) => {
    const recipientData = new Map({
      classroomId,
      classroomName,
      student
    });
    callAction(createAssignmentActions.SET_ACTIVE_RECIPIENT_GROUP, classroomId);
    if (e.which === 13 ? !e.target.checked : e.target.checked) {
      callAction(createAssignmentActions.ADD_SINGLE_RECIPIENT, recipientData);
      this.props.tracking.trackEvent({
        type: 'button',
        content: 'Selected individual student',
        event: 'click'
      });
    } else {
      callAction(createAssignmentActions.REMOVE_SINGLE_RECIPIENT, recipientData);
      this.props.tracking.trackEvent({
        type: 'button',
        content: 'Deselected individual student',
        event: 'click'
      });
    }
  };

  generateGroupMembers = (students) => {
    if (students.isEmpty()) {
      return null;
    }
    const selectedRecipients = createAssignmentStore.getSelectedRecipients();
    const classroomId = this.props.classroom.getId();
    const classroomName = this.props.classroom.getName();

    const studentsList = students
      .sortBy((student) => student.getLastName().toLowerCase())
      .map((student, key) => {
        let isDisabled = false;

        /*
         * We slugify the student ID's with their classroom ID so that every checkbox
         * has its own unique ID. Inputs with shared ID's will break HTML.
         */
        const studentId = student.getId();
        const memberIdSlug = `${classroomId}@${studentId}`;
        const checked =
          selectedRecipients.has(classroomId) &&
          selectedRecipients
            .getIn([classroomId, 'students'], new List()) // necessary?
            .findIndex((recipient) => recipient.getId() === studentId) !== -1;

        // In edit mode, teachers may not unassign students who have already begun the assignment
        if (createAssignmentStore.getIsEditMode() && !student.getStudentAssignments().isEmpty()) {
          const studentAssignmentInProgress =
            student
              .getStudentAssignments()
              .first()
              .getStudentRelationshipMeta()
              .get(studentId)
              .get('start_time') !== null;

          isDisabled = studentAssignmentInProgress;
        }

        return (
          <li className='acf__recipients-list-item acf__recipients-list-item--nested' key={key}>
            <CreateAssignmentRecipientItem
              checked={checked}
              nested
              disabled={isDisabled}
              id={memberIdSlug}
              name={`${student.getLastName()}, ${student.getFirstName()}`}
              onChange={(e) => this.handleSingleSelect(e, classroomId, classroomName, student)}
              value={studentId}
            />
          </li>
        );
      });
    return (
      <div>
        <ul className='acf__recipients-list acf__recipients-list--nested'>{studentsList}</ul>
      </div>
    );
  };

  render() {
    return <div>{this.generateGroupMembers(this.props.students)}</div>;
  }
}

export default CreateAssignmentRecipientStudents;
